import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { UserService } from './services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkLogin(state.url)
  }

  checkLogin(url: string) {
    if (this.userService.loggedIn()) {
      this.userService.redirectUrl = url;
      return true;
    } else {
      this.userService.redirectUrl = url;
      this.router.navigate(['/login']);
      return false;
    }
  }

}
